export class UndoRedoElement {
  constructor(undoFunc, redoFunc) {
      this.undoFunc = undoFunc;
      this.redoFunc = redoFunc;
  }
}

export class UndoStack {
  constructor() {
    this.undoRedoElements = [];
    this.curIdxToAddInBuffer = 0;
  }

  tryRedo() {
    if (this.curIdxToAddInBuffer < 0 || this.undoRedoElements.length === 0) {
      return;
    }

    if (this.curIdxToAddInBuffer >= this.undoRedoElements.length) {
      // can't redo at end of buffer
      return;
    }

    const undoRedoElement = this.undoRedoElements[this.curIdxToAddInBuffer];

    undoRedoElement.redoFunc();

    this.curIdxToAddInBuffer++;
  }

  tryUndo() {
    if (this.curIdxToAddInBuffer < 0 || this.undoRedoElements.length === 0) {
      return;
    }
    // undo!
    if (this.curIdxToAddInBuffer <= 0) {
      // can't undo at start of buffer
      return;
    }

    // 
    const undoRedoElement = this.undoRedoElements[this.curIdxToAddInBuffer - 1];

    undoRedoElement.undoFunc();

    this.curIdxToAddInBuffer--;
  }

  clearStack() {
    this.undoRedoElements = [];
    this.curIdxToAddInBuffer = 0;
  }

  addUndoRedoElement(undoRedoElement) {
      // if it is set, and not the last element...remove all after it
      if (this.curIdxToAddInBuffer >= 0 && this.curIdxToAddInBuffer < (this.undoRedoElements.length - 1)) {
          this.undoRedoElements.length = this.curIdxToAddInBuffer;
      }

      this.undoRedoElements.push(undoRedoElement);
      this.curIdxToAddInBuffer = this.undoRedoElements.length;
  } 
}